import { FC } from 'react'

import { useGetTranslations } from '@/root/shared-hooks'
import { RowContainer } from '@/root/modules/tuuleliinid'

interface CustomerInfoProps {
  customerEmail: string
  customerName: string
  customerPhoneNumber: string
  ticketNumber: number
}

const CustomerInfo: FC<CustomerInfoProps> = ({ customerEmail, customerName, customerPhoneNumber, ticketNumber }) => {
  const { getTranslation } = useGetTranslations()

  return (
    <RowContainer>
      <div className="min-w-0 text-2xl">{customerName}</div>
      <div className="flex w-full flex-col items-start pl-2 text-lg md:pl-0">
        <span className="leading-none">
          <p>{customerPhoneNumber}</p>
          <p className="[overflow-wrap:anywhere] break-words">{customerEmail}</p>
        </span>
      </div>
      <div className="flex w-full items-center gap-2 text-lg leading-none md:justify-end">
        {getTranslation('ticketPrintedTicketNumber')}
        <p className="text-2xl font-medium">{ticketNumber}</p>
      </div>
    </RowContainer>
  )
}

export default CustomerInfo
